<template>
  <div>
    <main id="main" :class="hasTouch" role="main">
      <transition name="square" mode="out-in">
        <nuxt />
      </transition>
    </main>
  </div>
</template>

<script>
export default {
  computed: {
    hasTouch() {
      return process.browser && 'ontouchstart' in document.documentElement
        ? 'has-touch'
        : false
    },
  },
  created() {
    this.viewportEventHandler()
  },
  mounted() {
    window.addEventListener('resize', this.viewportEventHandler)
  },
  destroyed() {
    window.removeEventListener('resize', this.viewportEventHandler)
  },
  methods: {
    viewportEventHandler() {
      this.$store.dispatch('globals/setDisplayViewport')
    },
  },
}
</script>

<style lang="scss">
@import '../assets/scss/settings.scss';
@import '../assets/scss/styles.scss';

body {
  min-width: 375px;
  background-color: black;
}
</style>
